// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden-image {
  height: 20px;
  width: 20px;
}

.filter-image {
  height: 14px;
  width: 14px;
}

.reset-text {
  border: 1px solid var(--artistic-tags-chips-teal-50, #EDF4F7);
  background: var(--artistic-structural-0, #FFF);
}

.info {
  height: 16px;
  width: 16px;
  margin-left: 4px;
}

.addViewPopup {
  display: flex;
}

/*service-desk specific AGGrid scrollbar fix (service-desk uses a different version of AGGrid)*/
.ag-body.ag-layout-normal {
  height: 100%;
  overflow-x: auto !important;
  overflow-y: auto !important;
}

.ag-body.ag-layout-normal::-webkit-scrollbar {
  display: none !important;
}

.ag-body-vertical-scroll {
  display: none;
 }

.ag-body .ag-body-viewport {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/workItemsTable/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,+FAA+F;AAC/F;EACE,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;CACd;;AAED;EACE,sBAAsB;AACxB","sourcesContent":[".hidden-image {\n  height: 20px;\n  width: 20px;\n}\n\n.filter-image {\n  height: 14px;\n  width: 14px;\n}\n\n.reset-text {\n  border: 1px solid var(--artistic-tags-chips-teal-50, #EDF4F7);\n  background: var(--artistic-structural-0, #FFF);\n}\n\n.info {\n  height: 16px;\n  width: 16px;\n  margin-left: 4px;\n}\n\n.addViewPopup {\n  display: flex;\n}\n\n/*service-desk specific AGGrid scrollbar fix (service-desk uses a different version of AGGrid)*/\n.ag-body.ag-layout-normal {\n  height: 100%;\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n}\n\n.ag-body.ag-layout-normal::-webkit-scrollbar {\n  display: none !important;\n}\n\n.ag-body-vertical-scroll {\n  display: none;\n }\n\n.ag-body .ag-body-viewport {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
